export const AUTH_CACHE_EPOCH_BYTES = 16;

const browserRandomValues = bytes => {
  const cryptoApi = typeof window !== 'undefined' ? window.crypto : null;
  if (!cryptoApi?.getRandomValues) throw new Error('Secure random values are unavailable');
  return cryptoApi.getRandomValues(bytes);
};

export const createOpaqueAuthCacheEpoch = (getRandomValues = browserRandomValues) => {
  const bytes = new Uint8Array(AUTH_CACHE_EPOCH_BYTES);
  getRandomValues(bytes);
  return Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
};

export const createAuthCacheEpochManager = ({ getRandomValues = browserRandomValues } = {}) => {
  let authenticatedSubject = null;
  let cacheEpoch = null;

  const clear = () => {
    authenticatedSubject = null;
    cacheEpoch = null;
  };

  return {
    authenticate(subject) {
      if (subject === null || subject === undefined || subject === '') {
        clear();
        return null;
      }
      if (authenticatedSubject !== subject || !cacheEpoch) {
        cacheEpoch = createOpaqueAuthCacheEpoch(getRandomValues);
        authenticatedSubject = subject;
      }
      return cacheEpoch;
    },
    clear,
    current: () => cacheEpoch,
  };
};
